module.exports = __webpack_public_path__ + "img/2019110801.97a4e2d4.jpg";